"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NewCardForm {
}
exports.default = NewCardForm;
//# sourceMappingURL=NewCardForm.js.map